import React__default, { useContext } from 'react';
import { HoverCard } from '@deal/components';
import { ChatActionsContext } from '../../containers/ChatActions/index.js';
import classnames from 'classnames';
import MenuDots from './menu-dots.svg.js';
import styles from './styles.css.js';

var ChatActions = function ChatActions(_a) {
  var messagePart = _a.messagePart,
      children = _a.children;
  var messageAction = useContext(ChatActionsContext).messageAction;
  var MessageAction = messageAction;
  return messageAction && messageAction.handlesMessagePart(messagePart) ? React__default.createElement("div", {
    className: classnames(styles.container)
  }, React__default.createElement("div", {
    className: styles.messageContent
  }, children), React__default.createElement(HoverCard, {
    placement: "top",
    size: "small",
    interactive: true,
    subTitleContent: MessageAction && React__default.createElement(MessageAction, {
      messagePart: messagePart
    }),
    tippyChildClassName: styles.tippyChild,
    hoverCardClassName: styles.hoverCard
  }, React__default.createElement(MenuDots, {
    className: styles.icon
  }))) : React__default.createElement(React__default.Fragment, null, children);
};

export default ChatActions;
//# sourceMappingURL=index.js.map
